import { Link } from "react-router-dom";
import { UserSquare, Star, ChevronsDown, GitBranch, ArrowRight, Globe } from "lucide-react";
import { motion } from "framer-motion";
import './Home.css';

// Komponen Kartu Fitur (Tidak berubah)
const FeatureCard = ({ to, title, imgSrc }) => (
  <div className="feature-card-container">
    <div className="thumbnail-wrapper">
      <img src={imgSrc} alt={title} className="card-thumbnail" />
    </div>
    <div className="info-wrapper">
      <h3 className="card-title">{title}</h3>
      <Link to={to} className="card-button">
        <span>Buka</span>
        <ArrowRight className="icon" />
      </Link>
    </div>
  </div>
);

// --- REVISI: Komponen untuk item komunitas diubah menjadi tombol ---
const CommunityRole = ({ role, community, icon }) => (
    <div className="community-item-button">
        {icon}
        <span className="community-role-button">{role}:</span>
        <span className="community-name-button">{community}</span>
    </div>
);

export default function Home() {
  const features = [
    { to: "/mbti", title: "MBTI ID Card Generator", imgSrc: "https://i.ibb.co/GZqWBBy/YOUR-NAME-Card-Front.png" },
    { to: "/pp", title: "Profile Pic Generator", imgSrc: "https://i.ibb.co/Gq84sBM/ISTJ-Profile-Pic.png" },
    { to: "/gup", title: "GUP Generator", imgSrc: "https://i.ibb.co/nqPB0k3n/NAMA-KARAKTER-GUP-Card.png" },
    { to: "/dev", title: "Developer Card", imgSrc: "https://i.ibb.co/kgzTD1JG/Nama-Programmer-Dev-Card.png" },
    { to: "/it", title: "IT Role Card", imgSrc: "https://i.ibb.co/Xx9g64Qj/Nawfal-IT-Role-Card.png" }
  ];

  // --- REVISI: Data disederhanakan untuk format tombol ---
  const communityRoles = [
    { role: "Admin", community: "Ukhuwah Hijrah", icon: <UserSquare size={16} /> },
    { role: "Admin", community: "La Maison Typology", icon: <UserSquare size={16} /> },
    { role: "Admin", community: "Personality Insight", icon: <UserSquare size={16} /> },
    { role: "Moderator", community: "Medievalist Indonesia", icon: <Star size={16} /> },
    { role: "Moderator", community: "Diary Introvert Indonesia", icon: <Star size={16} /> }
  ];

  return (
    <div className="homepage-container">
      <div className="aurora-background">
        <div className="aurora-blob" style={{'--color': '#3b82f6'}}></div>
        <div className="aurora-blob" style={{'--color': '#a855f7'}}></div>
      </div>
      <div className="noise-overlay"></div>

      <header className="main-header">
        <div className="header-content">
          <div className="logo">
            <GitBranch className="logo-icon"/>
            Id card Manager
          </div>
          <nav className="main-nav">
            <a href="#features" className="nav-button">Fitur</a>
            <a href="#about" className="nav-button">Tentang Saya</a>
            <a href="#community" className="nav-button">Komunitas</a>
                        <a href="https://naufalicious.vercel.app/" target="_blank" rel="noopener noreferrer" className="nav-button flex items-center gap-x-2">
                <Globe size={16} />
                <span>Website Utama</span>
            </a>
          </nav>
        </div>
      </header>

      <main className="main-content">
        <section className="hero-section">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="hero-title">
            Ekspresikan Identitas Digital Anda
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="hero-subtitle">
            Platform terpusat untuk membuat kartu identitas digital berdasarkan berbagai sistem tipologi kepribadian dan peran profesional.
          </motion.p>
          <motion.a href="#features" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.4 }} className="hero-cta-button">
            Lihat Semua Generator
            <ChevronsDown className="ml-2 w-5 h-5" />
          </motion.a>
        </section>

        <section id="features" className="content-section">
          <h2 className="section-title">Pilih Generator Kartu</h2>
          <div className="features-grid">
            {features.map((feature, i) => (
              <FeatureCard key={i} {...feature} />
            ))}
          </div>
        </section>

        <section id="about" className="content-section">
          <h2 className="section-title">Tentang Saya</h2>
          <div className="about-me-card">
            <div className="about-me-text">
                <h3 className="about-me-name">Nawfal Sayf Al Aswad</h3>
                <p className="about-me-description">
                    Saya Nawfal, Kita semua ingin dimengerti, dan saya ingin menciptakan sesuatu yang membantu orang mengenal dirinya sendiri dengan cara yang menyenangkan. Kalau satu orang merasa dikenali lewat karya ini, itu sudah cukup bagiku :).
                </p>
            </div>
          </div>
        </section>

<section id="community" className="content-section">
  <h2 className="section-title">Peran & Komunitas</h2>
  <div className="community-list-buttons flex flex-wrap gap-4 justify-center">
    {communityRoles.map((role, i) => (
      <CommunityRole 
        key={i} 
        {...role} 
        className="bg-blue-800 text-white px-6 py-3 rounded-lg hover:bg-blue-900 transition-colors duration-200"
      />
    ))}
  </div>
</section>
      </main>

      <footer className="main-footer">
          <p>Dibuat oleh Nawfal Sayf Al Aswad</p>
          <p>&copy; {new Date().getFullYear()} Id card Manager. All Rights Reserved.</p>
      </footer>
    </div>
  );
}
